const { getSetOfPolylines } = require('./helpers')

google.maps.LatLng.prototype.kmTo = function(a){ 
	var e = Math, ra = e.PI/180; 
	var b = this.lat() * ra, c = a.lat() * ra, d = b - c; 
	var g = this.lng() * ra - a.lng() * ra; 
	var f = 2 * e.asin(e.sqrt(e.pow(e.sin(d/2), 2) + e.cos(b) * e.cos 
	(c) * e.pow(e.sin(g/2), 2))); 

	return f * 6378.137;	
};

google.maps.Polyline.prototype.inKm = function(n){ 
	var a = this.getPath(n), len = a.getLength(), dist = 0; 
	for (var i=0; i < len-1; i++) { 
	   dist += a.getAt(i).kmTo(a.getAt(i+1)); 
	}
	return dist; 
};

const MAP_MARKER_Z_INDEX = 1000;
const PARTICIPANT_MARKER = 999;
const USER_MARKER = 1500;

const displayStartFlag = (markerPosition, map) => {
	new google.maps.Marker({
		position: markerPosition,
		map: map,
		icon: '/public/images/map/flag-start.png',
		zIndex: MAP_MARKER_Z_INDEX
	});
}

const displayFinishFlag = (markerPosition, map) => {
	new google.maps.Marker({
		position: markerPosition,
		map: map,
		icon: '/public/images/map/flag-finish.png',
		zIndex: MAP_MARKER_Z_INDEX
	});
}

const milestoneWidth = isConquerorMission ? 65 : 44;
const milestoneHeight = isConquerorMission ? 216 : 160;

const displayMilestones = (milestones, map, listener) => {

	if (milestones !== undefined && milestones !== null && milestones.length > 0) {
		for (let i = 0; i < milestones.length; i++) {
			var milestone = milestones[i];

			var milestoneLatLng = new google.maps.LatLng(milestone.lat, milestone.lng);

			var markerIcon = {
				size: new google.maps.Size(milestoneWidth, milestoneHeight),
				// The origin for this image is (0, 0).
				origin: new google.maps.Point(0, 0),
				url: "/" + milestone.image,
				anchor: new google.maps.Point(milestoneWidth/2, milestoneHeight/2)
			};

			// Place a milestone marker
			var milestoneMarker = new google.maps.Marker({
				position: milestoneLatLng,
				map: map,
				icon: markerIcon,
				zIndex: MAP_MARKER_Z_INDEX
			});

			milestoneMarker.set('marker_id', milestone.id);
			milestoneMarker.set('mission_id', milestone.mission_id);
			milestoneMarker.set('node_lat', milestone.lat);
			milestoneMarker.set('node_lng', milestone.lng);
			milestoneMarker.set('type', 'milestone');

			if (listener) {
				google.maps.event.addListener(milestoneMarker, "click", listener);
			}
		}
	}
}

const polyOptions = {
	strokeColor: '#e53921',
	strokeOpacity: 0.7,
	strokeWeight: 5
};

const polyOptionsTravelled = {
	strokeColor: '#49a6d1',
	strokeOpacity: 0.7,
	strokeWeight: 5
};

const polyOptionsSkip = {
	strokeColor: '#818181',
	strokeOpacity: 0.3,
	strokeWeight: 4,
	icons: [
	  {
		icon: {
			path: "M 0,-1 0,1",
			strokeOpacity: 1,
		},
		offset: "0",
		repeat: "20px",
	  },
	],
};

let endMarkerPosition;
let travelledDistance = 0;

window.viewMissionMapInit = () => {
	var ownerAddedDistanceZoomLevel = 15;
	var geocoder = new google.maps.Geocoder();

	var myOptions = {
		zoom: zoomLevel,
		center: new google.maps.LatLng(lat,lng),
		mapTypeId: google.maps.MapTypeId.TERRAIN,
		disableDefaultUI: false,
		disableDoubleClickZoom: true,
		zoomControl: zoomControl,
		panControl: false,
		maxZoom: 20,
		scrollwheel: false,
		mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN]
		}
	};

	if (typeof isReactNativeWebView !== 'undefined' && isReactNativeWebView) {
		myOptions.disableDefaultUI = true;
		myOptions.streetViewControl = window.displayRNStreetView ? true : false;
		myOptions.zoomControl = false;
		myOptions.zoomLevel = ownerAddedDistanceZoomLevel;
		ownerAddedDistance = true; // wil force zoom in on user
	}

	var infoBubbleOptions = {
		minWidth: 300,
		shadowStyle: 0,
		borderColor: 'rgba(0,0,0,0.1)',
	};

	const infoWindow = new InfoBubble(infoBubbleOptions)

	map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

	var bounds = new google.maps.LatLngBounds();
	mapBounds = bounds;

	google.maps.event.addListener(map, 'idle', function() {
		refreshZoom();
	});

	displayMilestones(milestones, map, displayInfoWindow)

	let totalPolylineDistance = 0; // calculated distance as we go along each segment on the polyline

	var distanceNodes = [];
	var nodeDistanceMarkers = [];

	google.maps.event.addListener(map, 'projection_changed', function() {
		$.ajax({
			type: 'GET',
			url: '/default/ajax?ajax=get_encoded_polyline',
			data: { mission_id: missionId }
		}).done(function( { data } ) {
			const setOfPolylines = getSetOfPolylines(data);

			// First coordinate - display start flag
			const firstCoordinate = setOfPolylines[0].markerLatLng;
			startMarkerPosition = firstCoordinate;
			displayStartFlag(startMarkerPosition, map)
			bounds.extend(firstCoordinate);

			// Last coordinate - display last flag
			const [lastPath] = setOfPolylines.slice(-1);
			const [lastCoordinate] = lastPath.path.slice(-1);
			endMarkerPosition = lastCoordinate;
			displayFinishFlag(endMarkerPosition, map)

			displayMap(setOfPolylines);

			// Update the mission with this latlng
			if (!isConquerorMission) {
				$.post('/default/ajax?ajax=mission_lat_lng', {
					mission_id: missionId,
					lat: endMarkerPosition.lat(),
					lng: endMarkerPosition.lng(),
				});
			}
		});
	});

	function displayMap(polylines) {
        var projection = map.getProjection();
        if (!projection || pathsLoaded == true) return;

		const importantMarkersWithNoDistance = participantDistances.filter(
            (participant) =>
                +participant.orig_distance === 0 &&
                (participant.type === 'pace_car' || participant.is_me),
        );

		const firstCoordinate = polylines[0].markerLatLng;
		const coordinatePoint = projection.fromLatLngToPoint(firstCoordinate);

		importantMarkersWithNoDistance.forEach(participant => {
			// Add important markers with distance === 0
			addParticipantToMap({participant, projection, nodeStartPoint: coordinatePoint, nodeEndPoint: coordinatePoint, nodeDistanceBetweenFraction: 0});
		})

		// Remove participants with distance === 0
		participantDistances = participantDistances.filter(participant => +participant.orig_distance > 0);

        polylines.forEach((polyline) => {
			bounds.extend(polyline.markerLatLng);
			// Handle hidden polylines
            if (polyline.style === 'hidden') {
                return;
            }

			const newPolyline = new google.maps.Polyline({
				// Only pass path so we can calculate path distance
				path: polyline.path,
			});

			// Handle skipped polylines
            if (polyline.style === 'skipped') {
				newPolyline.setMap(map);
				newPolyline.setValues(polyOptionsSkip);
                return;
            }

			// Handle no participants left to add to map
			const isAnyParticipantLeft =
                participantDistances.length > 1 ||
                (participantDistances.length === 1 && participantDistances[0].type !== 'pace_car');

			if (!isAnyParticipantLeft) {
				newPolyline.setMap(map);
				newPolyline.setValues(polyOptions);
                return;
			}

			const currentPolylineDistance = newPolyline.inKm();

			// Increment calculate distance so far
			const currentPathDistance = totalPolylineDistance + currentPolylineDistance;
			totalPolylineDistance = Math.min(currentPathDistance, totalDistance);

			// Handle already passed polyline
			handlePolylineWithParticipant({polyline, currentPolylineDistance, projection });
        });

        // Update the pathsLoaded variable so this isn't run more than once
        pathsLoaded = true;

        //var markerCluster = new MarkerClusterer(map, nodeDistanceMarkers, { imagePath: '/skin/default/images/map-clusters/mvm', minimumClusterSize: 20, gridSize: 22 });
        var markerCluster = new MarkerClusterer(map, nodeDistanceMarkers, {
            imagePath: '/skin/default/images/map-clusters/mvm',
            minimumClusterSize: 8,
            gridSize: 26,
        });

        if (!ownerAddedDistance) {
            map.fitBounds(bounds);
        }

        if (typeof shouldEnableStreetview != 'undefined') {
            if (shouldEnableStreetview == 1) {
                loadSvLatLng = new google.maps.LatLng(loadSvLat, loadSvLng);

                initStreetview(map.getStreetView(), loadSvLatLng, loadSvHeading);
            }
        }

        // only start streetview once and only if user press streetview
        let isStreetViewStarted = false;

        window.addEventListener('message', (event) => {
            if (event.data === 'toggle_streetview') {
                if (!isStreetViewStarted) {
                    initRNStreetView();
                }
                toggleStreetview();
            }
        });

        window.rnZoomToLocation = userMarkerLocation;
        //var fenway = { lat: -37.7781096, lng: 176.1165639 };
        window.rnUserMarkerLocation = userMarkerLocation;

        if (userMarkerLocation === undefined) {
            window.rnUserMarkerLocation = endMarkerPosition;
        }

		// Allow coordinate override for RN streetview
		window.rnInitialCoordinate = window.rnUserMarkerLocation;

		if (!!(overrideLat && overrideLng)) {
			window.rnInitialCoordinate = new google.maps.LatLng(overrideLat,overrideLng);
			map.setCenter(window.rnInitialCoordinate);
		}

        if (
            typeof isReactNativeWebView !== 'undefined' &&
            isReactNativeWebView &&
            displayRNStreetView
        ) {
            initRNStreetView();
        } else {
            sendReactNativeMessage('loaded');
        }

        function initRNStreetView() {
            isStreetViewStarted = true;

            var panorama = new google.maps.StreetViewPanorama(document.getElementById('pano'), {
                position: window.rnInitialCoordinate,
                disableDefaultUI: true,
                pov: {
                    heading: 34,
                    pitch: 10,
                },
            });

            function streetViewMessage(rnStatus, message = '') {
                var pano = document.getElementById('pano');
                var pano_message = document.getElementById('pano_message');

                if (message !== '') {
                    pano.style.display = 'none'; // hide streetview
                    pano_message.style.display = 'flex'; // show message
                    pano_message.innerText = message;
                } else {
                    pano.style.display = 'flex'; // show streetview
                    pano_message.style.display = 'none'; // hide message
                    pano_message.innerText = '';
                }

                sendReactNativeMessage(rnStatus);
            }

            panorama.addListener('visible_changed', function () {
                if (panorama.getVisible()) {
                    streetViewMessage('visible');
                } else {
                    streetViewMessage(
                        'not_visible',
                        'Google has not recorded a StreetView at this location. \n\n Place pegman on the map for StreetView.',
                    );
                }
            });

            panorama.addListener('position_changed', function () {
                var service = new google.maps.StreetViewService();
                service.getPanoramaByLocation(
                    panorama.location.latLng,
                    15,
                    function (streetViewPanoramaData, status) {
                        if (status === google.maps.StreetViewStatus.OK) {
                            streetViewMessage('visible');
                        } else {
                            streetViewMessage(
                                'no_results',
                                'Sorry, StreetView could not be loaded.',
                            );
                        }
                    },
                );
            });

            streetViewMessage('loaded');

            map.setStreetView(panorama);

            // Display all markers
            displayStartFlag(startMarkerPosition, panorama);
            displayFinishFlag(endMarkerPosition, panorama);
            displayMilestones(milestones, panorama);

            // duplicate markers from default map
            nodeDistanceMarkers.map((marker) => {
                new google.maps.Marker({
                    position: marker.getPosition(),
                    map: panorama,
                    icon: marker.getIcon(),
                    zIndex: marker.getZIndex(),
                });
            });

            window.rnPanorama = panorama;
        }

        getWeatherConditions();
    }

	function displayInfoWindow() {
		listenerThis = this;
		const thisType = this.get('type');
		const thisMarkerId = this.get('marker_id');
		const thisMissionId = this.get('mission_id');
		const nodeLat = this.get('node_lat');
		const nodeLng = this.get('node_lng');

		const params = { user_id: thisMarkerId, mission_id: thisMissionId, type: thisType, appv2_user_id: userId }

		if (thisType !== 'solo') {
			$.ajax({
				url: "/default/ajax?ajax=get_marker_user_info",
				type: "POST",
				data: params,
				dataType: 'json',
				success: function(data) {
					var relative_url = '/user/index/'+data['user_id'];

					const markerTemplate = document.getElementById("user-marker-template");
					const content = markerTemplate.content.cloneNode(true);

					content.querySelector("#user-marker-template-title").innerText = data.name;
					content.querySelector("#user-marker-template-title").style.cursor = 'default';

					content.querySelector("#user-marker-template-avatar").src = data.avatar_img;

					switch (data.type) {
						case "pace_car":
						case "milestone":
						case "team":
							content.querySelector("#user-marker-template-subtitle").innerText = data.message;
							break;

						case "user":
							content.querySelector("#user-marker-template-title").style.cursor = 'pointer';
							content.querySelector("#user-marker-template-subtitle").innerText = data.country_name;

							content.querySelector("#user-marker-template-avatar").classList.add("user-avatar");

							content.querySelector("#user-marker-template-country").style.display = 'block';
							content.querySelector("#user-marker-template-country").src = "/public/images/flags/square/" + data.country_code + ".png";


							if (typeof isReactNativeWebView === 'undefined' || !isReactNativeWebView) {
								content.querySelector("#user-marker-template-avatar-wrapper").href = relative_url;
								content.querySelector("#user-marker-template-avatar-wrapper").rel = "tooltip";
								content.querySelector("#user-marker-template-avatar-wrapper").title = "Go to " + data.name  + "'s profile";

								content.querySelector("#user-marker-template-title-wrapper").href = relative_url;
								content.querySelector("#user-marker-template-title-wrapper").rel = "tooltip";
								content.querySelector("#user-marker-template-title-wrapper").title = "Go to " + data.name  + "'s profile";
							}
							break;
					}

					content.querySelector("#user-marker-template-distance").innerText = data.distance;
					content.querySelector("#user-marker-template-distance-unit").innerText = data.distance_unit;
					content.querySelector("#user-marker-template-pct").innerText = data.distance_pct + '%';

					if (window.displayRNStreetView) {
						content.querySelector("#user-marker-template-streetview").href = 'javascript:switchStreetview(\''+nodeLat+'\',\''+nodeLng+'\');';
					}
					else {
						// streetview is disabled, so hide button
						content.querySelector("#user-marker-template-streetview").classList.add('d-none');
					}

					infoWindow.setContent(content);
					infoWindow.open(map, listenerThis);
				}
			})
		}
	}

	function sendReactNativeMessage(message) {
		if (typeof message === 'string') {
			message = {
				type: 'action',
				message: message,
			};
		}

		message = JSON.stringify(message);

		if (window.ReactNativeWebView !== undefined) {
			window.ReactNativeWebView.postMessage(message);
		}
	}

	if (window.ReactNativeWebView === undefined) {
		recorded_panorama_event = false;
		panorama = map.getStreetView();
		google.maps.event.addListener(panorama,'pano_changed', function() {
			if (panorama.getPano() && recorded_panorama_event != true) {
				// Record event
				if (typeof ga != 'undefined') {
					ga('send', 'event', 'StreetView', 'drag', 'Streetview dragged on view mission page');
				}
				recorded_panorama_event = true;
			}
		});
	}

    const handlePolylineWithParticipant = ({polyline, currentPolylineDistance, projection}) => {
		const travelledPath = [];
		const notReachedPath = [];

		// Remove currentPolylineDistance so we can loop through path from start of polyline
		let pathsTotalDistance = totalPolylineDistance - currentPolylineDistance;

		polyline.path.forEach((latLng, pathIndex) => {
			if (pathIndex === 0) {
				travelledPath.push(latLng);
				return;
			}

			const previousLatLng = polyline.path[pathIndex - 1];

			if (!participantDistances[0]) {
				notReachedPath.push(latLng);
				return;
			}

			const pathDistance = getDistanceFromLatLngInKm(
				previousLatLng.lat(),
				previousLatLng.lng(),
				latLng.lat(),
				latLng.lng()
			)

			const prevDistance = pathsTotalDistance;
			pathsTotalDistance += pathDistance;

			// We don't want to include pace car to be considered as travelled 
			const isValidParticipantLeft = (participants => participants.some(participant => participant['type'] === 'user' || participant['type'] === 'team'));

			// there's no participant yet
			if (+participantDistances[0]['orig_distance'] > pathsTotalDistance) {
				if (isValidParticipantLeft(participantDistances)) {
					travelledPath.push(latLng);
					return;
				}
				notReachedPath.push(latLng);
				return;
			}

			const participantsWithinDistance = participantDistances.filter(
                (participant) =>
                    (participant.orig_distance > prevDistance &&
                        participant.orig_distance <= pathsTotalDistance) ||
                    (participant.orig_distance === 0 && prevDistance === 0), // Also include distances === 0
            );

			const [lastParticipant] = participantDistances.filter(participant => participant.type !== 'pace_car').reverse();

			const isLastParticipantInThisPolyline = lastParticipant?.orig_distance < pathsTotalDistance;

			participantsWithinDistance.some((participant) => {
				const isLastParticipant = participant.id === lastParticipant?.id;

				// Do not add last participant now (we do it later)
				// We need to break polyline in 2 to show different colors (progressed and not progressed)
				if (isLastParticipant && isLastParticipantInThisPolyline) {
					participantDistances.shift();
					return false;
				}
				travelledPath.push(latLng);

				const participantDistance = +participant['orig_distance']; // in km

				// Passes the polyline path
				// So, ignore from now, rest of the participants will be added to future paths
				if (participantDistance > totalPolylineDistance) {
					return true;
				}

				// start and finish point of the path
				const nodeStartPoint = projection.fromLatLngToPoint(previousLatLng);
				const nodeEndPoint = projection.fromLatLngToPoint(latLng);
				// % of the path where the participant is
				const nodeDistanceBetweenFraction = getParticipantDistanceFractionInPolyline(participantDistance, pathsTotalDistance, pathDistance);

				addParticipantToMap({participant, projection, nodeStartPoint, nodeEndPoint, nodeDistanceBetweenFraction});

				// Remove just added participant
				participantDistances.shift();
			})

			if (!isLastParticipantInThisPolyline || !lastParticipant) {
				return false;
			}

			// Handle lastParticipant
			const nodeStartPoint = projection.fromLatLngToPoint(previousLatLng);
			const nodeEndPoint = projection.fromLatLngToPoint(latLng);
			// % of the path where the participant is
			const nodeDistanceBetweenFraction = getParticipantDistanceFractionInPolyline(+lastParticipant['orig_distance'], pathsTotalDistance, pathDistance);

			const nodeLatLngBetween = addParticipantToMap({participant: lastParticipant, projection, nodeStartPoint, nodeEndPoint, nodeDistanceBetweenFraction});

			travelledPath.push(nodeLatLngBetween);

			// Give the start point as the previous path point
			notReachedPath.push(nodeLatLngBetween);
			notReachedPath.push(latLng);
		})

		// Add travelled part
		if (travelledPath.length > 1) {
			new google.maps.Polyline({
				...polyOptionsTravelled,
				map,
				path: travelledPath,
			});
		}

		// Add not reached part
		if (notReachedPath.length > 1) {
			new google.maps.Polyline({
				...polyOptions,
				map,
				path: notReachedPath,
			});
		}
    };

	const addParticipantToMap = ({participant, projection, nodeStartPoint, nodeEndPoint, nodeDistanceBetweenFraction}) => {
		travelledDistance = +participant['orig_distance'];

        let zIndexMarker = PARTICIPANT_MARKER;

        // Handle crossing the meridian
        if (Math.abs(nodeEndPoint.x - nodeStartPoint.x) > 128) {
            if (nodeEndPoint.x > nodeStartPoint.x) {
                nodeEndPoint.x -= 256;
            } else {
                nodeEndPoint.x += 256;
            }
        }

        var x =
            nodeStartPoint.x + (nodeEndPoint.x - nodeStartPoint.x) * nodeDistanceBetweenFraction;
        var y =
            nodeStartPoint.y + (nodeEndPoint.y - nodeStartPoint.y) * nodeDistanceBetweenFraction;

        var nodePointBetween = new google.maps.Point(x, y);
        var nodeLatLngBetween = projection.fromPointToLatLng(nodePointBetween);

        var image = {
            url: '/' + participant['image'],
        };

        isPaceCar = false;

        if (participant['type'] === 'pace_car') {
            image.size = new google.maps.Size(80, 145);
            image.origin = new google.maps.Point(0, 0);
            image.scaledSize = new google.maps.Size(35, 63); // scaled size: need to scale not to change mobile marker size
            image.anchor = new google.maps.Point(17.5, 60); // must be half of x and y to be in the correct place

            zIndexMarker = MAP_MARKER_Z_INDEX;

            isPaceCar = true;
        } else if (participant['is_me']) {
            zIndexMarker = USER_MARKER;
            userMarkerImage = image;
        }

        // Place marker
        var nodeDistanceMarker = new google.maps.Marker({
            position: nodeLatLngBetween,
            map: map,
            zIndex: zIndexMarker,
            icon: image,
            anchor: false,
        });
        zIndexMarker = PARTICIPANT_MARKER; // reset

        if (userId > 0) {
			if (participant['is_me']) {
                if (ownerAddedDistance) {
                    map.setCenter(nodeLatLngBetween);
                    map.setZoom(ownerAddedDistanceZoomLevel);
                }

                userMarkerLocation = nodeLatLngBetween;
                nodeDistanceMarker.set('is_me', true);
            } else {
                nodeDistanceMarker.set('is_me', false);
            }
        }

        if (isPaceCar) {
            nodeDistanceMarker.set('is_me', true);
        }

        nodeDistanceMarker.set('marker_id', participant['user_id']);
        nodeDistanceMarker.set('mission_id', missionId);
        nodeDistanceMarker.set('node_lat', nodeLatLngBetween.lat());
        nodeDistanceMarker.set('node_lng', nodeLatLngBetween.lng());
        nodeDistanceMarker.set('type', participant['type']);

        google.maps.event.addListener(nodeDistanceMarker, 'click', displayInfoWindow);

        // Add marker to list of markers
        nodeDistanceMarkers.push(nodeDistanceMarker);

        // Record marker location
        distanceNodes.push(nodeLatLngBetween);

		return nodeLatLngBetween;
    };

	const getParticipantDistanceFractionInPolyline = (participantTotalDistance, pathsTotalDistance, currentPathDistance) => {
		// Distance difference between participant distance and polyline distance
		const participantDistanceInCurrentPath = pathsTotalDistance - participantTotalDistance;

		const fractionDifferenceFromPolylineEnd = participantDistanceInCurrentPath / currentPathDistance;

		// Convert to fraction from start of polyline
		const fractionDifferenceFromPolylineStart = 1 - fractionDifferenceFromPolylineEnd;

		return fractionDifferenceFromPolylineStart;
	}
}
